<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" :class="[`${prefix}-icon`, `${prefix}-icon-pen`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_e00b1dd036__a"><rect width="14" height="14" rx="0"/></clipPath></defs><g clip-path="url(#svg_e00b1dd036__a)"><path d="M1.00270642,12.8626C1.5638640000000001,10.71818,4.51341,2.1533100000000003,12.8852,1.000212846C12.9526,0.99606441,13.0074,1.0531546,12.9992,1.119129C12.9357,1.983706,12.4698,3.33954,10.00205,4.42441C9.94038,4.45648,9.92703,4.53764,9.97528,4.58719C10.20926,4.8026,10.94293,4.69538,11.3405,4.62423C11.3667,4.622590000000001,11.3917,4.63546,11.4053,4.65761C11.4188,4.67975,11.4187,4.70747,11.4049,4.7295C11.055,5.31433,10.124,6.70915,6.92361,7.38756C6.86512,7.39925,6.87107,7.49283,6.93055,7.50258L7.66224,7.62637C7.74685,7.64676,7.78795,7.74121,7.74453,7.81546C7.41339,8.36618,5.88755,9.81949,3.31872,10.03587C3.14966,10.04963,2.99679,10.14009,2.90529,10.28053C2.4561599999999997,10.95894,1.5638640000000001,12.1208,1.1078000000000001,12.9201C1.0681418,12.9815,0.983869,12.9347,1.00270642,12.8626ZM11.2582,13Q2.02191,12.8801,2.02191,12.732L11.2582,12.4649C11.4084,12.4649,11.5303,12.5843,11.5309,12.732C11.5309,12.88,11.4088,13,11.2582,13Z" :fill="useCurrentColor ? 'currentColor' : '#8739E2'"/></g></svg>
</template>
<script>

export default {
  name: 'IconPen',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
